var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sb_scene",staticStyle:{"transform":"translate(-50%, -50%) scale(3)"},style:({
    transform: 'translate(-50%, -50% ) translateZ(0) scale(' + _vm.scale + ')',
  })},[_c('div',{staticClass:"sb_scene_content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }